import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API
});

// Add an interceptor to include the authorization header in all requests
api.interceptors.request.use((config: any) => {
    const savedToken = window.localStorage.getItem('dbmar-token');
    if (savedToken) {
        // Check if token is an SSO token (starts with 'c3Nv', which is Base64 for 'sso:')
        if (savedToken.startsWith('c3Nv')) {
            config.headers.Authorization = `Bearer ${savedToken}`;
        } else {
            config.headers.Authorization = `Basic ${savedToken}`;
        }
    }
    return config;
});

// Add a response interceptor to improve error messages globally
api.interceptors.response.use(
    (response) => response,
    (error) => {
        try {
            const data = error?.response?.data;

            // Case 1 — Nginx HTML error pages (502, 503, 504, etc.)
            if (typeof data === 'string' && data.includes('<title>')) {
                const match = data.match(/<title>(.*?)<\/title>/i);
                if (match && match[1]) {
                    const cleanMessage = match[1]; // e.g. "502 Bad Gateway"
                    error.message = cleanMessage;
                    // Also update response.data so all error handlers see the clean message
                    if (error.response) {
                        error.response.data = cleanMessage;
                    }
                }
            }
            // Case 2 — plain text error
            else if (typeof data === 'string' && data.trim().length > 0) {
                error.message = data;
                // Data is already clean plain text, keep it as is
            }
            // Case 3 — JSON with .message field
            else if (data && typeof data.message === 'string' && data.message.trim().length > 0) {
                error.message = data.message;
                // Keep the JSON structure intact
            }
        } catch {
            // In case anything above throws, fall back to the original error unchanged.
        }

        return Promise.reject(error);
    }
);

export default api;
